import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { TABLE_VIEW_TYPE } from 'tuc-webui-base/services/ViewService';
import withRouteContext from 'tuc-webui-base/components/utils/withRouteContext';
import { withStoreData } from 'grb-webui/store';
import fromConfiguration from 'grb-webui/configuration/fromConfiguration';
import { NON_AGGREGATED_JOBS_ENTITY } from '../../Entities';
import { JOB_STATUS_QUEUED_VALUE } from '../../services/JobService';
import './NonAggregatedJobPanel.scss';

export default (options = {}) => {
  const getJobAddress = options.jobService.getJobAddress.bind(options.jobService);
  const getJobStatus = options.jobService.getJobStatus.bind(options.jobService);

  const makeNodeTableModels = (models) => {
    const nodeModels = models.slice();
    nodeModels[0].data = [];
    return nodeModels;
  };
  const getRowId = job => `${job.id}-${getJobAddress(job)}`;

  const JOB_TYPE = 'Job';
  const NonAggregatedJobPanel = (props) => {
    const {
      filter,
      arrayFilter,
      onFilterChange,
      filterEditor,
      [NON_AGGREGATED_JOBS_ENTITY]: jobs,
      component,
      tableModel,
      configuration,
      ...rest
    } = props;
    const [Table] = useState(() => props.viewService.getComponent(TABLE_VIEW_TYPE));
    const [models] = useState(() => [{
      ...component.configuration.data,
      ...tableModel,
      getRowId,
    }]);
    const [tableConfig] = useState(() => {
      return {
        ...component.configuration.table,
        getTableRowId: obj => `job-row-${getRowId(obj)}`,
      };
    });
    const [Tabs] = useState(() => fromConfiguration(component.detailsComponent, props));
    const [groupNodes] = useState([]);
    // As multiple tables in the master component and one selection only is
    // possible to be displayed in the details component,
    // selection must be centralized here
    const [selected, setSelected] = useState([]);

    const handleSelect = useCallback((newSel) => {
      setSelected(newSel);
    }, []);

    const filterSelected = useCallback((group) => {
      if (!selected || !selected.length) return [];
      return selected.filter(job => getJobAddress(job) === group);
    }, [selected]);

    // Clear address group data
    groupNodes.forEach((node) => {
      const n = node;
      n.models = makeNodeTableModels(models);
    });

    // Fill address group data with provided jobs
    const filteredJobs = (arrayFilter ? arrayFilter(jobs) : jobs).filter((job) => {
      return getJobStatus(job) === JOB_STATUS_QUEUED_VALUE;
    });
    filteredJobs.forEach((job) => {
      const address = getJobAddress(job);
      let node = groupNodes.find(g => g.address === address);
      if (!node) {
        const nodeModels = models.slice();
        nodeModels[0].data = [];
        node = {
          address,
          jobs: [job],
          configuration: tableConfig,
          models: makeNodeTableModels(models),
        };
        groupNodes.push(node);
      }
      node.models[0].data.push(job);
    });

    return (
      <div className="grb-jobqueuenoaggr-panel">
        <div className="grb-jobqueuenoaggr-table-list">
          {groupNodes.filter(n => n.models[0].data.length).map((n, i) => (
            <section key={n.address} className="grb-jobqueue-section">
              <header>
                <Typography variant="body1">{`Node ${n.address}`}</Typography>
              </header>
              <Table
                {...rest}
                selected={filterSelected(n.address)}
                configuration={n.configuration}
                models={n.models}
                onSelect={handleSelect}
                ensureSelection={!i && (!selected || !selected.length)}
              />
            </section>
          ))}
        </div>
        <div className="grb-jobqueuenoaggr-details">
          {selected && !!selected.length && (
            <Tabs
              {...rest}
              data={selected[0]}
              type={JOB_TYPE}
            />
          )}
        </div>
      </div>
    );
  };

  NonAggregatedJobPanel.propTypes = {
    viewService: PropTypes.shape({
      onError: PropTypes.func,
      getComponent: PropTypes.func,
    }).isRequired,
    component: PropTypes.shape({
      configuration: PropTypes.shape({
        data: PropTypes.shape({}),
        table: PropTypes.shape({}),
      }),
      detailsComponent: PropTypes.shape({}),
    }).isRequired,
    route: PropTypes.shape({}).isRequired,
    location: PropTypes.shape({
      state: PropTypes.shape({
        selectedBatchId: PropTypes.string,
      }),
    }).isRequired,
    arrayFilter: PropTypes.func,
    onFilterChange: PropTypes.func,
    filter: PropTypes.shape({}),
    filterEditor: PropTypes.shape({}),
    onSnackbarMessage: PropTypes.func.isRequired,
    tableModel: PropTypes.shape({}),
  };

  NonAggregatedJobPanel.defaultProps = {
    filter: undefined,
    arrayFilter: undefined,
    onFilterChange: undefined,
    filterEditor: undefined,
    tableModel: undefined,
  };

  return withStoreData(withRouteContext(NonAggregatedJobPanel), {
    entities: [{
      name: NON_AGGREGATED_JOBS_ENTITY,
    }],
    clearOnUnsubscribe: true,
  });
};
